import SubmenuList from './SubmenuList';

export default SubmenuList;
